import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable, signal } from '@angular/core';
import { SharedDataService } from 'elbuild-ui-lib-core';
import { BehaviorSubject, Subject } from 'rxjs';
import { MAX_WIDTH_1024PX, MAX_WIDTH_767PX, MIN_WIDTH_1025PX, MIN_WIDTH_768PX } from '../const';


@Injectable({
  providedIn: 'root'
})
export class ThemeLayoutService {



  constructor(private sharedDataService: SharedDataService, private breakpointObserver: BreakpointObserver) {
    if (this.breakpointObserver.isMatched(MAX_WIDTH_767PX)) {
      this.ismobile.next(true);
      this.islargescreen.next(false);
      this.screensize.next('mobile');
    } else if (this.breakpointObserver.isMatched(MIN_WIDTH_768PX)) {
      this.ismobile.next(false);
      if (this.breakpointObserver.isMatched(MIN_WIDTH_1025PX)) {
        this.islargescreen.next(true);
        this.screensize.next('largedesktop');
      } else if (this.breakpointObserver.isMatched(MAX_WIDTH_1024PX)) {
        this.islargescreen.next(false);

        this.screensize.next('desktop');

      }
    }
    this.breakpointObserver.observe([MIN_WIDTH_768PX, MAX_WIDTH_767PX, MIN_WIDTH_1025PX, MAX_WIDTH_1024PX]).subscribe((result: any) => {
      if (result.breakpoints[MAX_WIDTH_767PX]) {
        this.ismobile.next(true);
        this.islargescreen.next(false);
        this.screensize.next('mobile');
      } else if (result.breakpoints[MIN_WIDTH_768PX]) {
        this.ismobile.next(false);
        if (result.breakpoints[MIN_WIDTH_1025PX]) {
          this.islargescreen.next(true);
          this.screensize.next('largedesktop');
        } else if (result.breakpoints[MAX_WIDTH_1024PX]) {
          this.islargescreen.next(false);

          this.screensize.next('desktop');
        }
      }
    });
  }

  screensize: BehaviorSubject<'mobile' | 'desktop' | 'largedesktop'> = new BehaviorSubject<'mobile' | 'desktop' | 'largedesktop'>('desktop');
  ismobile: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  islargescreen: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  // theme menu sidebar show and hide
  dashBoardMenuState = new Subject();

  // theme component page menu sidebar show and hide
  componentMenuState = new Subject();

  // theme sidebar direction change in rtl mode
  directionChange = signal<string>('');

  // color change
  color = signal<string>('');

  // layout change
  layout = signal<string>('');

  // themeMode Change
  isDarkMode = signal<string>('');

  drawerOpen = signal(false);
  componentDrawerOpen = signal(false);

  /**
   * Toggle Dashboard vertical menu
   */
  toggleSideDrawer() {
    this.dashBoardMenuState.next(!this.drawerOpen());
    this.sharedDataService.sendAction('toggleside', this.drawerOpen());

  }

  /**
   * Toggle Component vertical menu
   */
  toggleMenuSide() {
    this.componentMenuState.next(!this.componentDrawerOpen());
  }
}
